import { BoolFieldLayout } from '../../layouts/bool-field-layout.component';
import type { BasicBoolFieldProps } from '../../layouts/types';
import { Switch } from './switch.component';

export const SwitchField = (props: BasicBoolFieldProps<'switch'>) => {
  return <BoolFieldLayout {...props} field={Switch} />;
};
